import type { ReactNode } from 'react';

import { AiIcon, PlayIcon } from '../../shared/ui/icons';
import { SectionPanel } from '../../shared/ui/section-panel';

const Row = ({ icon, title, text }: { icon: ReactNode; title: string; text: string }) => (
  <div className="flex items-start gap-3 border-t border-border-sunken px-card py-3 first:border-t-0">
    <span className="mt-hair flex text-muted">{icon}</span>
    <div>
      <p className="text-data text-primary">{title}</p>
      <p className="mt-hair text-meta leading-18 text-muted">{text}</p>
    </div>
  </div>
);

/** Board S4: what the budget running out does — and that nothing fails. */
export const RunsOutCard = ({ reset }: { reset: string }) => (
  <SectionPanel title="When it runs out" note="nothing fails">
    <Row
      icon={<AiIcon size="sm" />}
      title="AI steps hold their copies"
      text="Classify, Extract and Generate put copies on hold instead of calling the model; an agent waits before its next model call and goes on from there. They show as Paused · AI budget."
    />
    <Row
      icon={<PlayIcon size="sm" />}
      title="Tests of drafts are refused"
      text="Until the budget is raised or the day resets."
    />
    <p className="border-t border-border-sunken bg-field-muted px-card py-3 text-meta leading-18 text-muted">
      Held work goes on by itself at {reset} UTC, or as soon as someone raises the budget. An issue
      opens when it runs out, so whoever follows issues hears of it.
    </p>
  </SectionPanel>
);
